export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Грудь`, `50`, `52`, `54`, `56`, `58`, `60`, `63`],
  [`Длина`, `65`, `67`, `69`, `71`, `73`, `75`, `77`]
];
